module.exports = "img/icons-settings-room.942b673.svg";